/// <amd-module name="Build/Common/Library/PipelinesL2Header" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export class PipelinesL2Header extends VssService implements IBreadcrumbItemService {
    
    private items = new ObservableArray<IBreadcrumbItem>();
    
    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        // hide the duplicate "Pipelines" hub
        this.items.push({
            key: "Hub",
            text: "",
            priority: 100,
            hidden: true
        });
        return this.items;
    }
}

Services.add("pipelines-l2-breadcrumb-service", { serviceFactory: PipelinesL2Header });
